import React, { useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import Sidebar from '../component/sidebar/sidebar';
import { useCookies } from "react-cookie";
import './layout.css';

const ControlPanelLayout = () => {
  const navigate = useNavigate();
  const [cookies, , removeCookie] = useCookies(["user"]);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleLogout = () => {
    removeCookie("user", { path: "/" });
		removeCookie("token", { path: "/" });
		localStorage.removeItem("user");
		localStorage.removeItem("token");
		localStorage.removeItem("userId");
		navigate("/");
  };

  return (
    <div className="control-panel-container">
      {/* Mobile Sidebar Overlay */}
      {sidebarOpen && (
        <div
          className="sidebar-overlay"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Sidebar */}
      <Sidebar
        handleLogout={handleLogout}
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
      />

      {/* Main Content Area */}
      <div className="control-panel-content">
        {/* Mobile Top bar with hamburger */}
        <div className="cp-topbar">
          <button
            className="sidebar-toggle-btn"
            onClick={() => setSidebarOpen(!sidebarOpen)}
            aria-label="Toggle sidebar"
          >
            <span className="hamburger-line" />
            <span className="hamburger-line" />
            <span className="hamburger-line" />
          </button>
          <span className="cp-topbar-title">⚙️ Control Panel</span>
        </div>

        <Outlet />
      </div>
    </div>
  );
};

export default ControlPanelLayout;